import { z } from 'zod';

export const orderSyncErrorSchema = z.object({
  errorDescription: z.string(),
  lastSyncAttemptAt: z.number(),
  orderUuid: z.string(),
  /** The order may have failed Zod validation, so allow any types to be stored */
  order: z.any().optional(), // .any() needs have .optional() so it Convex converts to it's own type accurately. Maybe fixed in Zod v4.
  syncAttempts: z.number(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  restaurantId: z.string().optional(),
});
export type OrderSyncError = z.output<typeof orderSyncErrorSchema>;

export const orderSyncErrorStrictSchema = orderSyncErrorSchema.safeExtend({
  orderUuid: z.guid(),
});

export const orderSyncErrorCvxSchema = orderSyncErrorSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  restaurantId: z.string(),
});
export type OrderSyncErrorCvx = z.output<typeof orderSyncErrorCvxSchema>;
